import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import {
    IDLE, PENDING,
    LIST, ADD, EDIT,
} from "const"
import { MarkovModel } from "server/models"
import { StateType, deepCopy, hasAccess } from "client/utils"
import { markovModelsRoute } from "client/parts/routes"
import {
    PRM_MARKOV_MODEL,
    StoreType,
    MarkovModelList,
    MarkovModelFilters,

    LoadAllMarkovModels,
    DeleteMarkovModel,
    SortMarkovModels,

    setMarkovModelList,
    setMarkovModelIds,
    setMarkovModelSort,
    setMarkovModelFilters,
    addModal,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    Loader,
    Button,
    Table,
    TableSearchWrapper,
    SortRows,
    DeleteRow,
} from "client/components"

import AccessDenied from "client/parts/accessDenied"
import MarkovModelSearch from "client/pages/search/markovModelSearch"
import Columns from "./columns"


const List = () => {
    const modelList = useSelector((state: StoreType) => state.markovModel.modelList)
    const modelIds = useSelector((state: StoreType) => state.markovModel.modelIds)
    const sortColumn = useSelector((state: StoreType) => state.markovModel.sortColumn)
    const sortOrder = useSelector((state: StoreType) => state.markovModel.sortOrder)
    const filters = useSelector((state: StoreType) => state.markovModel.filters)
    const reloadList = useSelector((state: StoreType) => state.markovModel.reloadList)

    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [loadState, setLoadState] = useState<StateType>(IDLE)

    useEffect(() => {
        if (!reloadList) return
        setLoadState(PENDING)
        LoadAllMarkovModels(userData.accountId).then((res) => {
            dispatch(setMarkovModelList(res))
            setLoadState(IDLE)
        })
    }, [reloadList])

    useEffect(() => {
        const sortedIds = SortMarkovModels(Object.values(modelList), sortColumn, sortOrder, filters)
        dispatch(setMarkovModelIds(sortedIds))
    }, [modelList, sortColumn, sortOrder, filters])

    const onSort: SortRows = (column: keyof MarkovModel, order) => {
        dispatch(setMarkovModelSort(column, order))
    }

    const onFilter = (newFilters: MarkovModelFilters) => {
        dispatch(setMarkovModelFilters(newFilters))
    }

    const onDelete: DeleteRow = (model: MarkovModel, callback) => {
        DeleteMarkovModel(model.id, userData.accountId).then((removedRows) => {
            const success = removedRows === 1
            callback(success, () => {
                const modelListCopy: MarkovModelList = modelList ? deepCopy(modelList) : {}
                delete modelListCopy[model.id]
                dispatch(setMarkovModelList(modelListCopy))
                dispatch(setMarkovModelIds(modelIds.filter((id) => id !== model.id)))
            })
        })
    }

    const columns = Columns()

    const listAccess = hasAccess(PRM_MARKOV_MODEL, LIST)
    const addAccess = hasAccess(PRM_MARKOV_MODEL, ADD)

    // TODO: import xml
    if (!listAccess) return <AccessDenied />
    return (
        <Container>
            <PageHeader>
                <PageTitle>{lang.models}</PageTitle>
            </PageHeader>
            <PageContent>
                {
                    loadState === PENDING
                    && <Loader />
                }
                <TableSearchWrapper>
                    <MarkovModelSearch
                        id="modelList"
                        rightOffset={addAccess}
                        filters={filters}
                        onFilter={onFilter}
                    />
                    {
                        addAccess && (
                            <Button
                                variant="success"
                                onClick={() => dispatch(addModal({ url: `${markovModelsRoute}/${EDIT}/0` }))}
                            >
                                {lang.add}
                            </Button>
                        )
                    }
                </TableSearchWrapper>
                <Table
                    columns={columns}
                    dataList={modelList}
                    dataIds={modelIds}
                    sortColumn={sortColumn}
                    sortOrder={sortOrder}
                    rowSize="sm"
                    showPagination
                    onSort={onSort}
                    onDelete={onDelete}
                />
            </PageContent>
        </Container>
    )
}
export default List
